import {pluralize} from "@pg-mono/string-utils";

const applicationsPluralize = pluralize(["zapytanie", "zapytania", "zapytań"]);

export const getRegistrationSentApplicationsTitle = (count: number): string => `Wysłałeś/aś łącznie ${count} ${applicationsPluralize(count)}`;
import {pluralize} from "@pg-mono/string-utils";

const applicationsPluralize = pluralize(["zapytanie", "zapytania", "zapytań"]);

export const getRegistrationSentApplicationsTitle = (count: number): string => `Wysłałeś/aś łącznie ${count} ${applicationsPluralize(count)}`;
